var _path;
function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }
import * as React from "react";
function SvgTopDealCardBg(_ref, svgRef) {
  let {
    title,
    titleId,
    ...props
  } = _ref;
  return /*#__PURE__*/React.createElement("svg", _extends({
    width: 175,
    height: 317,
    viewBox: "0 0 175 317",
    fill: "none",
    xmlns: "http://www.w3.org/2000/svg",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    d: "M0 87.1388C0 39.0134 39.0134 0 87.1388 0C135.264 0 174.278 39.0134 174.278 87.1388V293.274C174.278 306.378 163.655 317 150.552 317H23.7259C10.6225 317 0 306.378 0 293.274V87.1388Z",
    fill: "#F3F3F3"
  })));
}
const ForwardRef = /*#__PURE__*/React.forwardRef(SvgTopDealCardBg);
export default __webpack_public_path__ + "static/media/top-deal-card-bg.3872e2b94ef3bff20ec22d4be7aeae7d.svg";
export { ForwardRef as ReactComponent };